import * as React from "react";
const SvgBBIconsLegend = (props) => (
  <svg
    data-name="chart legend"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style={{
      enableBackground: "new 0 0 200 200",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{display:none;}\n\t.st7{display:inline;}\n\t.st8{stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st9{opacity:0.9521;}\n"
      }
    </style>
    <g id="Global_report" />
    <g id="Obecn\xE9_ikony" />
    <g id="Horn\xED_menu__x2B__Footer" />
    <g id="Bo\u010Dn\xED_menu">
      <g>
        <path d="M51.5,134.5H23.9c-1.7,0-3,1.3-3,3v27.6c0,1.7,1.3,3,3,3h27.6c1.7,0,3-1.3,3-3v-27.6C54.5,135.9,53.2,134.5,51.5,134.5z" />
        <circle cx={37.7} cy={99.5} r={17.7} />
        <path d="M40.3,33.4c-1.2-2-4-2-5.2,0L20.3,59c-1.2,2,0.3,4.5,2.6,4.5h29.6c2.3,0,3.8-2.5,2.6-4.5L40.3,33.4z" />
        <path d="M79.2,53.2h95.4c3,0,5.5-2.5,5.5-5.5s-2.5-5.5-5.5-5.5H79.2c-3,0-5.5,2.5-5.5,5.5S76.1,53.2,79.2,53.2z" />
        <path d="M174.6,94H79.2c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5h95.4c3,0,5.5-2.5,5.5-5.5S177.6,94,174.6,94z" />
        <path d="M174.6,145.8H79.2c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5h95.4c3,0,5.5-2.5,5.5-5.5S177.6,145.8,174.6,145.8z" />
      </g>
    </g>
  </svg>
);
export default SvgBBIconsLegend;
